import { SearchResponse } from "interfaces/dataInterfaces"
import { IFetchingDetails } from "../../interfaces/survey"
import { householdApi } from "./householdApi"

export const fetchingOperationsApi = householdApi.injectEndpoints({
  endpoints: builder => ({
    getFetchingDetails: builder.query<
      SearchResponse<IFetchingDetails>,
      { surveyId: number; skip: number; take: number }
    >({
      query: query => ({
        url: `FetchingOperations/GetFetchingDetails`,
        params: query,
      }),
    }),
  }),
})

export const { useGetFetchingDetailsQuery } = fetchingOperationsApi
